module.exports = "/_next/static/images/Hero@2x-82b34d8912217a8bf2f2eeb9ff488518.png";